// extracted by mini-css-extract-plugin
export var carrierNotice = "_lg-5";
export var carrierNoticePlaceholder = "_lg-6";
export var deliveryRow = "_lg-c";
export var fixedHeight = "_lg-4";
export var freightLogo = "_lg-b";
export var fullWidth = "_lg-3";
export var priceColumn = "_lg-7";
export var radioSelected = "_lg-9";
export var radioUnselected = "_lg-8";
export var selectedOption = "_lg-2";
export var selectedOptionContainer = "_lg-1";
export var selection = "_lg-0";
export var tallSkeletonText = "_lg-a";